module.exports = __webpack_public_path__ + "static/olesya-e534472ee4f5b57095afbf5e40a12798.png";